/** Admin guide §6 — Position Types (`admin/PositionTypesTab.tsx`, Settings → Position Types). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Bullets, Callout, HelpSectionCard, Li, P, Screen, Shot } from '../HelpPrimitives.js';

export function AdminPositionTypes(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('admin-position-types')}>
      <Shot
        slug="admin-position-types"
        caption="Position type cards, each with its own list of additional questions."
      />
      <P>
        The list of position types recruiters choose from on the <Screen>Pre-Kickoff</Screen> screen
        (see the main guide&rsquo;s &ldquo;Starting a project&rdquo; topic). Click{' '}
        <Btn>Add Type</Btn>, or hover a card to edit or delete it.
      </P>
      <Bullets>
        <Li>
          <Btn>Name</Btn> is required.
        </Li>
        <Li>
          A dynamic list of <Btn>Additional questions</Btn> specific to that position type — use{' '}
          <Btn>Add question</Btn> for another row, or × to remove one. Blank rows are dropped
          automatically when you save.
        </Li>
      </Bullets>
      <Callout title="Deleting a type is immediate">
        <P>There is no confirmation step before a card&rsquo;s delete takes effect.</P>
      </Callout>
    </HelpSectionCard>
  );
}
